import AutomatedSummaryBuilderModal from './AutomatedSummaryBuilderModal';

export default AutomatedSummaryBuilderModal;
